export const products = [
  {
    id: 1,
    slug: "milan-bazar",
    title: "Milan Shop",
    price: 355,
    image: "/book/milan bazar.png",
    description:
      "Milan Shop is crafted to deliver a luxurious bathing experience with a rich, creamy lather and long-lasting freshness. Its gentle cleansing formula helps remove dirt, excess oil, and impurities while leaving your skin feeling soft, smooth, and refreshed. Perfect for daily use and suitable for all skin types.",
  },
  {
    id: 2,
    slug: "kalyan-bazar",
    title: "Kalyan Shop",
    price: 355,
    image: "/book/kalyan bazar.png",
    description:
      "Kalyan Shop combines effective cleansing with a refreshing fragrance to keep your skin clean and revitalized throughout the day. Its skin-friendly formula produces a rich foam that gently nourishes and refreshes your skin after every wash. Suitable for all skin types and everyday use.",
  },
  {
    id: 3,
    slug: "sridevi-bazar",
    title: "Sridevi Shop",
    price: 355,
    image: "/book/sridevi bazar.png",
    description:
      "Sridevi Shop is specially designed to provide deep cleansing with a silky-smooth feel. Its premium formula creates a rich lather that helps maintain fresh, healthy-looking skin while leaving behind a pleasant and long-lasting fragrance. Ideal for daily bathing.",
  },
  {
    id: 4,
    slug: "madhur-bazar",
    title: "Madhur Shop",
    price: 355,
    image: "/book/madhur bazar.png",
    description:
      "Madhur Shop offers a refreshing blend of gentle cleansing and luxurious care. Its creamy lather effectively removes impurities while helping your skin feel soft, moisturized, and naturally radiant after every bath. Suitable for all skin types.",
  },
  {
    id: 5,
    slug: "supreme-bazar",
    title: "Supreme Shop",
    price: 355,
    image: "/book/supreme bazar.png",
    description:
      "Supreme Shop delivers premium skincare with every bath. Enriched with a rich foaming formula, it gently cleanses the skin, leaving it fresh, smooth, and energized. Its long-lasting fragrance provides an enjoyable bathing experience every day.",
  },
  {
    id: 6,
    slug: "time-bazar",
    title: "Time Bazar Shop",
    price: 355,
    image: "/book/time bazar.png",
    description:
      "Time Bazar Shop is formulated to provide effective cleansing with lasting freshness. Its luxurious lather helps remove daily impurities while keeping the skin soft, hydrated, and refreshed. Designed for everyday use and suitable for all skin types.",
  },
  {
    id: 7,
    slug: "rajdhani-bazar",
    title: "Rajdhani Shop",
    price: 355,
    image: "/book/rajdhani bazar.png",
    description:
      "Rajdhani Shop is created for those who appreciate premium-quality skincare. Its gentle cleansing formula helps maintain clean, healthy-looking skin while offering a refreshing fragrance and a smooth, comfortable feel after every bath.",
  },
  {
    id: 8,
    slug: "main-bazar",
    title: "Main Bazar Shop",
    price: 355,
    image: "/book/main bazar.png",
    description:
      "Main Bazar Shop combines superior cleansing with gentle skin care. Its rich, creamy foam effectively cleanses while helping retain your skin's natural softness and freshness. A perfect choice for daily bathing and all skin types.",
  },
  {
    id: 9,
    slug: "andhra-bazar",
    title: "Andhra Bazar Shop",
    price: 355,
    image: "/book/andhra bazar.png",
    description:
      "Andhra Bazar Shop is designed to provide complete skin freshness with every wash. Its advanced cleansing formula creates a luxurious lather that helps remove dirt and impurities while leaving your skin soft, smooth, and beautifully refreshed. Suitable for everyday use.",
  },
];
